import React, { useEffect } from "react";
import cookie from "react-cookies";
import SearchForm from "components/SearchForm";
import MenuDesktop from "components/MenuDesktop";
import ProfileMenu from "components/ProfileMenu";
import { useNavigate } from "react-router-dom";
import { checkLogin } from "utils/wallet";
import { setAuthToken } from "utils/axios";
import { toast } from "react-toastify";

const Header = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (cookie.load("user") === undefined) {
      toast.warning("Please login to search!");
      return;
    } else if (cookie.load("user").organization !== "Gyde") {
      toast.warning("You are not in Gyde Organization.");
      return;
    } else {
      navigate("/search/all");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setAuthToken(token);
    !cookie.load("user") && checkLogin();
  }, []);

  return (
    <header className="bg-theme flex flex-col h-[180px] relative items-center sm:h-[230px] overflow-hidden">
      <img
        src="/logo-v.png"
        alt="logo"
        className="absolute w-28 h-24 top-8 left-12 hidden xl:block cursor-pointer"
        onClick={handleLogoClick}
      />
      <img
        src="/logo-h.png"
        alt="logo"
        className="xl:hidden h-12 object-contain mt-8"
        onClick={handleLogoClick}
      />
      {cookie.load("user") && (
        <div className="absolute top-[16px] right-[16px] md:right-0 sm:-right-4 z-50 overflow-hidden">
          <ProfileMenu />
        </div>
      )}
      <div className="flex flex-col containers xl:w-[1014px] lg:w-[714px]  gap-[15px] xl:mt-10 mt-6">
        <SearchForm />
        <div className="hidden xl:block">
          <MenuDesktop />
        </div>
      </div>
    </header>
  );
};

export default Header;
